import React from 'react'

const HowToUse = () => {
  return (
    <div>
      
    </div>
  )
}

export default HowToUse
